<template>
  <div class="mss-admin home mss-admin__dashboard">
    <v-wait :for="'societyLoading'">
      <HalfCircleSpinner slot="waiting" />
      <template slot="waiting">
        <div class="spinner-message my-3 text-center">
          Loading the society data...
        </div>
      </template>
      <template v-if="society">
        <div class="row mb-3">
          <b-col>
            <SocietyOverview :society="society" />
          </b-col>
        </div>
        <div class="mb-3">
          <info-section>
            <not-taken-society-metrics />
            <mss-admin-insights />
          </info-section>
        </div>
        <div class="mb-3">
          <connect-section>
            <mss-admin-ico-metrics />
          </connect-section>
        </div>
        <div class="row mb-3">
          <b-col>
            <QuestionnairesAndSurveys :society="society" />
          </b-col>
        </div>
      </template>
    </v-wait>
  </div>
</template>

<script>
import SocietyOverview from './SocietyOverview';
import QuestionnairesAndSurveys from './QuestionnairesAndSurveys';
import SocietyDataProvider from '@/mixins/SocietyDataProvider';
import InfoSection from '@/components/dashboard/InfoSection';
import NotTakenSocietyMetrics from '@/components/mss_admin/dashboard/metrics/NotTakenSocietyMetrics';
import MssAdminInsights from '@/components/mss_admin/dashboard/MssAdminInsights';
import { HalfCircleSpinner } from 'epic-spinners';
import ConnectSection from '@/components/dashboard/ConnectSection';
import MssAdminIcoMetrics from '@/components/mss_admin/dashboard/metrics/MssAdminIcoMetrics';

export default {
  name: 'Main',
  mixins: [SocietyDataProvider],
  components: {
    SocietyOverview,
    QuestionnairesAndSurveys,
    HalfCircleSpinner,
    InfoSection,
    NotTakenSocietyMetrics,
    MssAdminInsights,
    ConnectSection,
    MssAdminIcoMetrics,
  },
  mounted() {
    if (!this.society) {
      this.$wait.start('societyLoading');
    }
  },
  computed: {
    society() {
      return this.$store.getters.society;
    },
    societyName() {
      return this.society ? this.society.name : '';
    },
  },
  watch: {
    society: function () {
      if (this.society) {
        this.$wait.end('societyLoading');
      }
    },
  },
};
</script>

<style scoped></style>
